import type { ReactElement } from 'react';
import { View } from 'react-native';

import { DateEditorCard } from './DateEditorCard';
import type { LoggerDispatch } from './state/loggerDraft';
import { isTodayDraftPending } from './state/loggerDraftHelpers';
import type { LoggerDraft } from './state/loggerDraftTypes';
import type { makeStyles } from './loggerStyles';
import type { useTheme } from './theme';

// #386: «Date & duration» as the first block of the Info panel, with the rule
// that separates it from the notes below. Owns the AP-9c gate: an unstarted
// «today» draft has no clock yet, so there is nothing to show until Start.
// The panel always has a line after it (the notes, or «No notes»).
export function LoggerDateEditor({
  draft,
  dispatch,
  styles,
  theme,
  t,
}: {
  draft: LoggerDraft;
  dispatch: LoggerDispatch;
  styles: ReturnType<typeof makeStyles>;
  theme: ReturnType<typeof useTheme>;
  t: (k: string, opts?: Record<string, unknown>) => string;
}): ReactElement | null {
  if (isTodayDraftPending(draft)) return null;
  return (
    <View style={styles.notesPanelDateRule}>
      <DateEditorCard
        startedAt={draft.startedAt}
        endedAt={draft.endedAt}
        onSetStartedAt={(iso) =>
          dispatch({ type: 'set_started_at', startedAt: iso })
        }
        onSetEndedAt={(iso) =>
          dispatch({ type: 'set_ended_at', endedAt: iso })
        }
        theme={theme}
        t={t}
      />
    </View>
  );
}
